import { Container } from '@mui/material'
import React from 'react'
import ComingSoonImage from '../../Assets/Images/coming_soon.gif'
import './ComingSoon.scss'

const ComingSoon: React.FC = () => {
  return (
    <>
      <Container maxWidth='sm'>
        <div className='coming__soon'>
          <img src={ComingSoonImage} />
        </div>
      </Container>
    </>
  )
}

export default React.memo(ComingSoon)
